import { signal } from '@angular/core';
import { FieldTree, SchemaPathTree } from '@angular/forms/signals';
import { CableCommentsDto } from '../../../core/mceapi.client.generated';
import { Option, match, none, some } from '../../../shared/functions/functional';

export interface CableComments {
  cableUid: string;
  dataHTML: string;
}

export function buildCableCommentsSchema(_: SchemaPathTree<CableComments>) { };

export function createCableComments(cableUid: string, comments: Option<CableCommentsDto>) {
  return signal<CableComments>({
    cableUid: cableUid,
    dataHTML: match(() => '', (x: CableCommentsDto) => x.dataHTML ?? '')(comments),
  });
}

/// Create cable comments DTO. Some if they have been modified. None if they have not been modified.
export function createCableCommentsDeltaDto(comments: FieldTree<CableComments>) {
  return signal<Option<CableCommentsDto>>(
    comments.dataHTML().dirty()
      ? some({
        cableUid: comments.cableUid().value(),
        dataHTML: comments.dataHTML().value() })
      : none // no changes to comments
  );
}
